// extracted by mini-css-extract-plugin
export default {"containerFAQ":"FAQ_containerFAQ__WYOLB","FAQ":"FAQ_FAQ__VIB3Q","FAQTitulo":"FAQ_FAQTitulo__Ff2az","summaryIcon":"FAQ_summaryIcon__QbzJ6","FAQResposta":"FAQ_FAQResposta__TlX0M"};